<template>
    <div>
        <img src="../assets/chaxun.jpg" alt="">
        <div class='popContainer'>
            <div class="rollback" @click="rollback()">

            </div>
            <div class="times">
                {{currentTime}}
            </div>
        </div>
        <div class='popContainer2' >
            <div class="shuru">
                <div class="sousuo" @click.stop="accept()"></div>
                <div >
                    <input type="text" v-model="card" placeholder="请输入身份证号码">
                </div>
            </div>
            <p class="offOn" v-if="offOn" style="float:left;color: red;width: 200px;margin-left: 36%;font-size: 16px;margin-top: 80px">{{offValue}}</p>
            <div class="mima">
                <div class="mimazi">
                    <div class="mimazi1"  @click.stop="mima('1')"></div>
                    <div class="mimazi2"  @click.stop="mima('2')"></div>
                    <div class="mimazi3"  @click.stop="mima('3')"></div>
                    <div class="mimazi4"  @click.stop="mima('4')"></div>
                    <div class="mimazi5"  @click.stop="mima('5')"></div>
                    <div class="mimazi6"  @click.stop="mima('6')"></div>
                    <div class="mimazi7"  @click.stop="mima('7')"></div>
                    <div class="mimazi8"  @click.stop="mima('8')"></div>
                    <div class="mimazi9"  @click.stop="mima('9')"></div>
                    <div class="mimazi0"  @click.stop="mima('0')"></div>
                    <div class="mimaziX"  @click.stop="mima('X')"></div>
                    <div class="mimaziqr"  @click.stop="mima('qr')"></div>
                </div>
            </div>
        </div>
        <div class="goBack" @click="rollback()">

        </div>
    </div>
</template>

<script>
	import { goUserInfo , goUserList } from '@/api/user'
	export default {
		name: "inquire",
		data() {

			return {
				offOn: true,
				offValue: '',
				timer: "",
				currentTime: '',
				number: '',
				card: '',
				cardList:['440181199409242125',
					'440181199403176649',
					'440823199811280343',
					'440982199407253867',
					'440583200011261924',
					'310227199706220019',
					'430426200004182561',
                    '440181199903153021',
                    '371082199221057720',
					'445321199503050620',
                    '522401199804297624',
                    '440582199308115934',
                    '362202199701250044',
                    '422324198001044421',
                    '45212219811020094X',
                    '440104195911124115',
                    '440601195805170327',
                    '44128419941005002X',
                    '445381199307051761',
                    '430725197111232363',
                    '440902198504300411',
                    '440105197103240041',
                    '440111199410054237',
                    '440104195807255027',
                    '440104197510110029',
                    '512922197608100028',
                    '440112195512150324',
                    '469003199307046147',
                    '360403196408291519',
                    '440104199806140015',
                    '430103196510041542',
                    '420704197409260347',
                    '440106197601234046',
                    '440105196810058025',
                    '440102200107094024',
                    '44010319730529132X',
                    '440106199807154032',
                    '440105199009212721',
                    '441222197310181526',
                    '440103195810094248',
                    '440301199705085821',
                    '429006199102253320',
                    '42092219880530002X'
                ],
				userList: [{
					'username': '黄君钰',
					'age': 23,
					'gender': 2,
					'identityCard': '440301199705085821',
					'makeTime': '2020年5月6日',//制作日期
					'samplePosition': '01号罐A区01架05盒21-30号/81-90',//检测样本位置
					'detectionTime': '2020年05月09日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年5月6日',//制作日期
					'inTime': '2020年05月09日',//入库日期
					'cellPosition': '01号罐A区01架05盒21-30号/81-90',//冷冻位置
					'cellNum': '1.95*10^8',//细胞数量
					'survivalRate': '96.80%',//活率
					'cellTotalTubeNum': '10',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '2020.06.17',//使用日期
						'useNum': '1',//管数
						'operator': '简钜铜',//操作人
					}]
				},{
					'username': '孙超美',
					'age': 62,
					'gender': 2,
					'identityCard': '440103195810094248',
					'makeTime': '2020年4月27日',//制作日期
					'samplePosition': '01号罐A区01架05盒11-20号',//检测样本位置
					'detectionTime': '2020年04月31日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月27日',//制作日期
					'inTime': '2020年04月31日',//入库日期
					'cellPosition': '01号罐A区01架05盒11-20号',//冷冻位置
					'cellNum': '0.97*10^8',//细胞数量
					'survivalRate': '96.60%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '范凤娣',
					'age': 47,
					'gender': 2,
					'identityCard': '441222197310181526',
					'makeTime': '2020年4月08日',//制作日期
					'samplePosition': '01号罐A区01架05盒1-10号',//检测样本位置
					'detectionTime': '2020年04月11日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月08日',//制作日期
					'inTime': '2020年04月11日',//入库日期
					'cellPosition': '01号罐A区01架05盒1-10号',//冷冻位置
					'cellNum': '0.82*10^8',//细胞数量
					'survivalRate': '96.80%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '杨莉娜',
					'age': 30,
					'gender': 2,
					'identityCard': '440105199009212721',
					'makeTime': '2020年4月08日',//制作日期
					'samplePosition': '01号罐A区01架03盒91-100号',//检测样本位置
					'detectionTime': '2020年04月09日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月08日',//制作日期
					'inTime': '2020年04月09日',//入库日期
					'cellPosition': '01号罐A区01架03盒91-100号',//冷冻位置
					'cellNum': '1.40*10^8',//细胞数量
					'survivalRate': '97.10%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '陈恩铭',
					'age': 22,
					'gender': 1,
					'identityCard': '440106199807154032',
					'makeTime': '2020年4月07日',//制作日期
					'samplePosition': '01号罐A区01架03盒81-90号',//检测样本位置
					'detectionTime': '2020年04月09日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月07日',//制作日期
					'inTime': '2020年04月09日',//入库日期
					'cellPosition': '01号罐A区01架03盒81-90号',//冷冻位置
					'cellNum': '1.68*10^8',//细胞数量
					'survivalRate': '96.80%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '邵瑞萍',
					'age': 47,
					'gender': 2,
					'identityCard': '44010319730529132X',
					'makeTime': '2020年4月06日',//制作日期
					'samplePosition': '01号罐A区01架03盒61-70号',//检测样本位置
					'detectionTime': '2020年04月08日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月06日',//制作日期
					'inTime': '2020年04月08日',//入库日期
					'cellPosition': '01号罐A区01架03盒61-70号',//冷冻位置
					'cellNum': '1.38*10^8',//细胞数量
					'survivalRate': '96.80%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '朱  彤',
					'age': 19,
					'gender': 2,
					'identityCard': '440102200107094024',
					'makeTime': '2020年4月06日',//制作日期
					'samplePosition': '01号罐A区01架03盒51-60号',//检测样本位置
					'detectionTime': '2020年04月08日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月06日',//制作日期
					'inTime': '2020年04月08日',//入库日期
					'cellPosition': '01号罐A区01架03盒51-60号',//冷冻位置
					'cellNum': '1.18*10^8',//细胞数量
					'survivalRate': '97.20%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '夏  雨',
					'age': 51,
					'gender': 2,
					'identityCard': '440105196810058025',
					'makeTime': '2020年4月08日',//制作日期
					'samplePosition': '01号罐A区01架03盒71-80号',//检测样本位置
					'detectionTime': '2020年04月09日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年4月08日',//制作日期
					'inTime': '2020年04月09日',//入库日期
					'cellPosition': '01号罐A区01架03盒71-80号',//冷冻位置
					'cellNum': '1.19*10^8',//细胞数量
					'survivalRate': '96.20%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '邹  静',
					'age': 44,
					'gender': 2,
					'identityCard': '440106197601234046',
					'makeTime': '2020年3月26日',//制作日期
					'samplePosition': '01号罐A区01架03盒41-50号',//检测样本位置
					'detectionTime': '2020年03月30日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年3月26日',//制作日期
					'inTime': '2020年03月30日',//入库日期
					'cellPosition': '01号罐A区01架03盒41-50号',//冷冻位置
					'cellNum': '1.40*10^8',//细胞数量
					'survivalRate': '96.50%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '夏晚星',
					'age': 46,
					'gender': 2,
					'identityCard': '420704197409260347',
					'makeTime': '2020年3月24日',//制作日期
					'samplePosition': '01号罐A区01架03盒31-40号',//检测样本位置
					'detectionTime': '2020年03月26日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年3月24日',//制作日期
					'inTime': '2020年03月26日',//入库日期
					'cellPosition': '01号罐A区01架03盒31-40号',//冷冻位置
					'cellNum': '1.75*10^8',//细胞数量
					'survivalRate': '96.50%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '马东晔',
					'age': 55,
					'gender': 2,
					'identityCard': '430103196510041542',
					'makeTime': '2020年1月9日',//制作日期
					'samplePosition': '01号罐A区01架03盒21-30号',//检测样本位置
					'detectionTime': '2020年01月10日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年1月9日',//制作日期
					'inTime': '2020年01月10日',//入库日期
					'cellPosition': '01号罐A区01架03盒21-30号',//冷冻位置
					'cellNum': '1.05*10^8',//细胞数量
					'survivalRate': '96.40%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '梁楚枫',
					'age': 22,
					'gender': 1,
					'identityCard': '440104199806140015',
					'makeTime': '2020年1月6日',//制作日期
					'samplePosition': '01号罐A区01架03盒11-20号',//检测样本位置
					'detectionTime': '2020年01月10日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年1月6日',//制作日期
					'inTime': '2020年01月10日',//入库日期
					'cellPosition': '01号罐A区01架03盒11-20号',//冷冻位置
					'cellNum': '1.85*10^8',//细胞数量
					'survivalRate': '97.10%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '胡华林',
					'age': 56,
					'gender': 1,
					'identityCard': '360403196408291519',
					'makeTime': '2020年1月4日',//制作日期
					'samplePosition': '01号罐A区01架03盒01-10号',//检测样本位置
					'detectionTime': '2020年01月06日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2020年1月4日',//制作日期
					'inTime': '2020年01月06日',//入库日期
					'cellPosition': '01号罐A区01架03盒01-10号',//冷冻位置
					'cellNum': '1.98*10^8',//细胞数量
					'survivalRate': '96.20%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '陈帼花',
					'age': 26,
					'gender': 2,
					'identityCard': '469003199307046147',
					'makeTime': '2019年12月29日',//制作日期
					'samplePosition': '01号罐A区01架02盒91-100号',//检测样本位置
					'detectionTime': '2020年01月02日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年12月29日',//制作日期
					'inTime': '2020年01月02日',//入库日期
					'cellPosition': '01号罐A区01架02盒91-100号',//冷冻位置
					'cellNum': '1.26*10^8',//细胞数量
					'survivalRate': '96.80%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '刘爱玲',
					'age': 64,
					'gender': 2,
					'identityCard': '440112195512150324',
					'makeTime': '2019年12月13日',//制作日期
					'samplePosition': '01号罐A区01架02盒81-90号',//检测样本位置
					'detectionTime': '2019年12月19日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年12月19日',//制作日期
					'inTime': '2019年12月19日',//入库日期
					'cellPosition': '01号罐A区01架02盒81-90号',//冷冻位置
					'cellNum': '1.24*10^8',//细胞数量
					'survivalRate': '95.80%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '严林芳',
					'age': 43,
					'gender': 2,
					'identityCard': '512922197608100028',
					'makeTime': '2019年12月09日',//制作日期
					'samplePosition': '01号罐A区01架02盒71-80号',//检测样本位置
					'detectionTime': '2019年12月10日',//最近一次检测时间
					'totalTubeNum': '4',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年12月09日',//制作日期
					'inTime': '2019年12月10日',//入库日期
					'cellPosition': '01号罐A区01架02盒71-80号',//冷冻位置
					'cellNum': '0.67*10^8',//细胞数量
					'survivalRate': '96.50%',//活率
					'cellTotalTubeNum': '4',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '缪  静',
					'age': 44,
					'gender': 2,
					'identityCard': '440104197510110029',
					'makeTime': '2019年12月06日',//制作日期
					'samplePosition': '01号罐A区01架02盒61-70号',//检测样本位置
					'detectionTime': '2019年12月10日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年12月06日',//制作日期
					'inTime': '2019年12月10日',//入库日期
					'cellPosition': '01号罐A区01架02盒61-70号',//冷冻位置
					'cellNum': '1.31*10^8',//细胞数量
					'survivalRate': '96.30%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '冯玉英',
					'age': 61,
					'gender': 2,
					'identityCard': '440104195807255027',
					'makeTime': '2019年12月06日',//制作日期
					'samplePosition': '01号罐A区01架02盒51-60号',//检测样本位置
					'detectionTime': '2019年12月10日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年12月06日',//制作日期
					'inTime': '2019年12月10日',//入库日期
					'cellPosition': '01号罐A区01架02盒51-60号',//冷冻位置
					'cellNum': '1.29*10^8',//细胞数量
					'survivalRate': '95.70%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '王颖楷',
					'age': 25,
					'gender': 1,
					'identityCard': '440111199410054237',
					'makeTime': '2019年11月29日',//制作日期
					'samplePosition': '01号罐A区01架02盒31-50号',//检测样本位置
					'detectionTime': '2019年12月03日',//最近一次检测时间
					'totalTubeNum': '10',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年11月29日',//制作日期
					'inTime': '2019年12月03日',//入库日期
					'cellPosition': '01号罐A区01架02盒31-50号',//冷冻位置
					'cellNum': '3.05*10^8',//细胞数量
					'survivalRate': '96.20%',//活率
					'cellTotalTubeNum': '10',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '叶  苓',
					'age': 48,
					'gender': 2,
					'identityCard': '440105197103240041',
					'makeTime': '2019年11月27日',//制作日期
					'samplePosition': '01号罐A区01架02盒21-25号',//检测样本位置
					'detectionTime': '2019年12月03日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年11月27日',//制作日期
					'inTime': '2019年12月03日',//入库日期
					'cellPosition': '01号罐A区01架02盒21-25号',//冷冻位置
					'cellNum': '0.93*10^8',//细胞数量
					'survivalRate': '96.60%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '陈  韬',
					'age': 34,
					'gender': 1,
					'identityCard': '440902198504300411',
					'makeTime': '2019年11月24日',//制作日期
					'samplePosition': '01号罐A区01架02盒11-15号',//检测样本位置
					'detectionTime': '2019年11月28日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年11月24日',//制作日期
					'inTime': '2019年11月28日',//入库日期
					'cellPosition': '01号罐A区01架02盒11-15号',//冷冻位置
					'cellNum': '0.81*10^8',//细胞数量
					'survivalRate': '96.10%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '覃  华',
					'age': 48,
					'gender': 2,
					'identityCard': '430725197111232363',
					'makeTime': '2019年11月15日',//制作日期
					'samplePosition': '01号罐A区01架01盒91-95号',//检测样本位置
					'detectionTime': '2019年11月19日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年11月15日',//制作日期
					'inTime': '2019年11月19日',//入库日期
					'cellPosition': '01号罐A区01架01盒91-95号',//冷冻位置
					'cellNum': '1.19*10^8',//细胞数量
					'survivalRate': '97.40%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '廖燕红',
					'age': 26,
					'gender': 2,
					'identityCard': '445381199307051761',
					'makeTime': '2019年11月9日',//制作日期
					'samplePosition': '01号罐A区01架01盒81-85号',//检测样本位置
					'detectionTime': '2019年11月14日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年11月9日',//制作日期
					'inTime': '2019年11月14日',//入库日期
					'cellPosition': '01号罐A区01架01盒81-85号',//冷冻位置
					'cellNum': '1.01*10^8',//细胞数量
					'survivalRate': '96.10%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '陈颖怡',
					'age': 25,
					'gender': 2,
					'identityCard': '44128419941005002X',
					'makeTime': '2019年10月31日',//制作日期
					'samplePosition': '01号罐A区01架01盒71-75号',//检测样本位置
					'detectionTime': '2019年11月2日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年10月31日',//制作日期
					'inTime': '2019年11月2日',//入库日期
					'cellPosition': '01号罐A区01架01盒71-75号',//冷冻位置
					'cellNum': '0.8*10^8',//细胞数量
					'survivalRate': '97.60%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '梁  雪',
					'age': 61,
					'gender': 2,
					'identityCard': '440601195805170327',
					'makeTime': '2019年10月25日',//制作日期
					'samplePosition': '01号罐A区01架01盒51-55号',//检测样本位置
					'detectionTime': '2019年10月28日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年10月28日',//制作日期
					'inTime': '2019年10月28日',//入库日期
					'cellPosition': '01号罐A区01架01盒51-55号',//冷冻位置
					'cellNum': '1.13*10^8',//细胞数量
					'survivalRate': '96.5%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '0',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '黄建伟',
					'age': 59,
					'gender': 1,
					'identityCard': '440104195911124115',
					'makeTime': '2019年10月14日',//制作日期
					'samplePosition': '01号罐A区01架01盒41-45号',//检测样本位置
					'detectionTime': '2019年10月18日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年10月14日',//制作日期
					'inTime': '2019年10月18日',//入库日期
					'cellPosition': '01号罐A区01架01盒41-45号',//冷冻位置
					'cellNum': '1.06*10^8',//细胞数量
					'survivalRate': '96.10%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '0',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '赵燕燕',
					'age': 38,
					'gender': 2,
					'identityCard': '45212219811020094X',
					'makeTime': '2019年10月11日',//制作日期
					'samplePosition': '01号罐A区01架01盒31-35号',//检测样本位置
					'detectionTime': '2019年10月11日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年10月11日',//制作日期
					'inTime': '2019年10月14日',//入库日期
					'cellPosition': '01号罐A区01架01盒31-35号',//冷冻位置
					'cellNum': '1.5*10^8',//细胞数量
					'survivalRate': '96.00%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '0',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '赵文',
					'age': 39,
					'gender': 2,
					'identityCard': '422324198001044421',
					'makeTime': '2019年8月23日',//制作日期
					'samplePosition': '01号罐A区01架01盒21-25号',//检测样本位置
					'detectionTime': '2019年8月23日',//最近一次检测时间
					'totalTubeNum': '5',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2019年8月23日',//制作日期
					'inTime': '2019年8月23日',//入库日期
					'cellPosition': '01号罐A区01架01盒21-25号',//冷冻位置
					'cellNum': '0.8*10^8',//细胞数量
					'survivalRate': '96.2%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '',//使用日期
						'useNum': '0',//管数
						'operator': '',//操作人
					}]
				},{
					'username': '马**',
					'age': 29,
					'gender': 1,
					'identityCard': '440582199308115934',
					'makeTime': '2021年3月11日',//制作日期
					'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
					'detectionTime': '2021年11月20日',//最近一次检测时间
					'totalTubeNum': '1',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2021年3月11日',//制作日期
					'inTime': '2021年3月12日',//入库日期
					'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
					'cellNum': '1.5*10^8',//细胞数量
					'survivalRate': '98.5%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '2021年11月20日',//使用日期
						'useNum': '1',//管数
						'operator': '简钜铜',//操作人
					}]
				},{
					'username': '吴**',
					'age': 23,
					'gender': 2,
					'identityCard': '522401199804297624',
					'makeTime': '2021年3月11日',//制作日期
					'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
					'detectionTime': '2021年11月20日',//最近一次检测时间
					'totalTubeum': '1',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2021年3月11日',//制作日期
					'inTime': '2021年3月12日',//入库日期
					'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置N
					'cellNum': '1.5*10^8',//细胞数量
					'survivalRate': '98.5%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '2021年11月20日',//使用日期
						'useNum': '1',//管数
						'operator': '简钜铜',//操作人
					}]
				},{
					'username': '冯**',
					'age': 23,
					'gender': 2,
					'identityCard': '440181199903153021',
					'makeTime': '2021年3月11日',//制作日期
					'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
					'detectionTime': '2021年11月20日',//最近一次检测时间
					'totalTubeNum': '1',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2021年3月11日',//制作日期
					'inTime': '2021年3月12日',//入库日期
					'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
					'cellNum': '1.5*10^8',//细胞数量
					'survivalRate': '98.5%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '2021年11月20日',//使用日期
						'useNum': '1',//管数
						'operator': '简钜铜',//操作人
					}]
				},{
					'username': '李**',
					'age': 23,
					'gender': 2,
					'identityCard': '445321199503050620',
					'makeTime': '2021年3月11日',//制作日期
					'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
					'detectionTime': '2021年11月20日',//最近一次检测时间
					'totalTubeNum': '1',//管数简
					'sampleOperator': '简钜铜',//操作人
					'cellMakeTime': '2021年3月11日',//制作日期
					'inTime': '2021年3月12日',//入库日期
					'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
					'cellNum': '1.5*10^8',//细胞数量
					'survivalRate': '98.5%',//活率
					'cellTotalTubeNum': '5',//管数
					'cellOperator': '简钜铜',//操作人
					'UseRecord': [{
						'useTime': '2021年11月20日',//使用日期
						'useNum': '1',//管数
						'operator': '简钜铜',//操作人
					}]
				},{
						'username': '于**',
						'age': 25,
						'gender': 2,
						'identityCard': '371082199221057720',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数简
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '98.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},
					{
						'username': '何**',
						'age': 27,
						'gender': 2,
						'identityCard': '440181199409242125',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数简
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '98.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
                        }]
					},,
					{
						'username': '付*',
						'age': 35,
						'gender': 2,
						'identityCard': '42092219880530002X',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数简
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '98.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},,
					{
						'username': '张**',
						'age': 32,
						'gender': 2,
						'identityCard': '429006199102253320',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒1号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数简
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒5号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '98.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '郭**',
						'age': 27,
						'gender': 2,
						'identityCard': '440181199403176649',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒6号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒10号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '97.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '欧**',
						'age': 23,
						'gender': 2,
						'identityCard': '440823199811280343',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒11号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒15号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '97.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '黄**',
						'age': 27,
						'gender': 2,
						'identityCard': '440982199407253867',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒16号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒20号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '97.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '许**',
						'age': 21,
						'gender': 2,
						'identityCard': '440583200011261924',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒21号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒25号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '98.5%',//活率888888
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '马**',
						'age': 24,
						'gender': 1,
						'identityCard': '310227199706220019',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒26号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒30号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '97.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '雷**',
						'age': 21,
						'gender': 2,
						'identityCard': '430426200004182561',
						'makeTime': '2021年3月11日',//制作日期
						'samplePosition': '液氮罐A区1号架1号盒31号管',//检测样本位置
						'detectionTime': '2021年11月20日',//最近一次检测时间
						'totalTubeNum': '1',//管数
						'sampleOperator': '简钜铜',//操作人
						'cellMakeTime': '2021年3月11日',//制作日期
						'inTime': '2021年3月12日',//入库日期
						'cellPosition': '液氮罐A区1号架1号盒35号管',//冷冻位置
						'cellNum': '1.5*10^8',//细胞数量
						'survivalRate': '97.5%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '简钜铜',//操作人
						'UseRecord': [{
							'useTime': '2021年11月20日',//使用日期
							'useNum': '1',//管数
							'operator': '简钜铜',//操作人
						}]
					},{
						'username': '甘*',
						'age': 24,
						'gender': 2,
						'identityCard': '362202199701250044',
						'makeTime': '2021年3月12日',//制作日期
						'samplePosition': '26-30号',//检测样本位置
						'detectionTime': '2021年3月12日',//最近一次检测时间
						'totalTubeNum': '5',//管数
						'sampleOperator': '刘伟才',//操作人
						'cellMakeTime': '2021年3月12日',//制作日期
						'inTime': '2021年3月13日',//入库日期
						'cellPosition': '液氮罐A区01架09号盒21-25号管',//冷冻位置
						'cellNum': '1.4*10^8',//细胞数量
						'survivalRate': '97.00%',//活率
						'cellTotalTubeNum': '5',//管数
						'cellOperator': '刘伟才',//操作人
						'UseRecord': [{
							'useTime': '',//使用日期
							'useNum': '',//管数
							'operator': '',//操作人
						}]
					},

				]
			}
		},
		methods: {
			rollback(){
				this.$router.push('/navigation')
			},
			mima(value){

				if (value=='qr') {
				  console.log("点击了确认")
					this.getuserlist()
					// this.getUserInfo()
					// this.card=''
					// this.offValue='请输入正确的身份证号码'
					// this.offOn=true
          //           if(this.cardList.indexOf(this.card) == -1){
	        //             this.card=''
	        //             this.offValue='请输入正确的身份证号码'
          //           }else {
          //
          //
	        //             this.userList.map((item)=>{
	        //             	if(item.identityCard==this.card){
			    //                 this.card=''
			    //                 localStorage.setItem('rows', JSON.stringify(item));
			    //                 this.$router.push('/client')
          //                       return
          //                   }
          //               })
	                    // localStorage.setItem('rows', JSON.stringify(data));
	                    // this.$router.push('/client')
                    // }

				}else {
					this.card += value
				}
			},
			accept(text) {
				// alert("Input text: " + text);
				if (this.card=='') {
					// alert("请输入密码");
					this.card=''
					this.offValue='请输入身份证号码'
					this.offOn=true
				}else {
					if (this.card=='666666'){
						this.$router.push('/menu')
					}else{
						this.card=''
						// alert("密码错误");
						this.card=''
						this.offValue='请输入正确的身份证号码'
						this.offOn=true
					}
				}

				this.hide();
			},
            async getuserlist() {
			console.log("调用接口查询客户信息")
                let keyword = this.card

              console.log(keyword)

              let data = await goUserList({keyWord:keyword})
              console.log("调用接口查询客户信息")

              console.log(data.data[0])

              if (data.code == '200'){

                this.card=''
                localStorage.setItem('rows', JSON.stringify(data.data[0]));
                this.$router.push('/client')
                      return

              }else{
                this.card=''
                // alert("密码错误");
                this.card=''
                this.offValue='请输入正确的身份证号码'
                this.offOn=true

              }




            },
			async getUserInfo(){
				let {imei_error_code, data, imei_error_msg} = await goUserInfo({identityCard:this.card})
				if (imei_error_code=='0'){
					localStorage.setItem('rows', JSON.stringify(data));
					this.$router.push('/client')
				}else{
					this.card=''
					// alert(imei_error_msg);
					this.offValue=imei_error_msg
					this.offOn=true
				}
				console.log(rows,'123456')
			}
		},
		created() {
			this.offOn=false
			var _this = this;
			var times
			_this.timer = setInterval(function() {
				let  shi= new Date().getHours()
				let  fen= new Date().getMinutes()
				shi= shi <= 9 ? "0"+ shi : shi
				fen= fen <= 9 ? "0"+ fen : fen
				times =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					shi +
					":" +
					fen
				_this.currentTime= times
			}, 1000);
			// console.log(_this.currentTime)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    .goBack{
        width: 20%;
        height: 250px;
        /*background: crimson;*/
        position: absolute;
        top: 76%;
        left: 80%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .popContainer{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100px;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .rollback{
        width: 150px;
        height: 100px;
        /*background-color: red;*/
        position: absolute;
        top: 10px;
        left: 20px;
        right: 0;
        bottom: 0;
    }
    .popContainer .times{
        height: 20px;
        position: absolute;
        top: 80%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
    .popContainer2{
        position: absolute;
        width: 100%;
        height: 80%;
        top: 100px;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .shuru{
        width: 100%;
        height: 20%;
        position: relative;
        top: 100px;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .shuru .sousuo{
        height: 55px;
        width: 65px;
        /*background-color: red;*/
        position: absolute;
        top: 23%;
        left: 36%;
        right: 0;
        bottom: 0;
    }
    .shuru input{
        text-align:center;
        height: 50px;
        width: 400px;
        background:none;
        color: #999999;
        border:none;
        outline:none;
        font-size: 20px;
        position: absolute;
        top: 26%;
        left: 40%;
        right: 0;
        bottom: 0;
    }
    .mima{
        width: 100%;
        height: 80%;
        position: relative;
        top: 120px;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .mima .mimazi{
        width: 555px;
        height: 530px;
        /*background-color: red;*/
        position: absolute;
        top: 40px;
        left: 36%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .mima .mimazi div{
        width: 175px;
        height: 130px;
        margin-top: 2px;
        margin-left: 5px;
        /*background-color: red;*/
        /*border: 1px solid red;*/
        float: left;
    }

</style>



// WEBPACK FOOTER //
// src/views/inquire.vue